import LeadNotificationCard from './LeadNotificationCard.component';

export default LeadNotificationCard;
